// 配送信息文案组件

import * as React from 'react';
import './index.css';
import { RichText } from '@wmfe/mach-pro-components-react';

interface Props {
  data: any;
  showRateInfo?: boolean; //是否展示店铺评分
  tabValue?: string; //是否自提
  setMarginTop?: number; //上外边距
}

interface State {}

const shopInfoTag = {
  shopScore: 'shopScoreInfo', //评分
  shopSale: 'shopSaleInfo', // 销量
  shopCategory: 'shopCategoryName', // 分类
  shopMinCost: 'minCostPrice', //最低消费
  shopAvgCost: 'shopAvgSpend', //人均
};

export default class ShopInfo extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      imgTagWidth: 1,
    };
  }

  render() {
    const { data, setMarginTop = 0 } = this.props;
    if (!data) return null;

    const {
      shopBasicLabelOrder = ['shopScoreInfo', 'shopSaleInfo', 'avgCostPrice', 'shopCategoryName', 'minCostPrice'], //展示顺序数组
      shopScoreInfo = {}, //评分
      shopSaleInfo = {}, // 销量
      shopCategoryName = '', // 分类
      minCostPrice = {}, //最低消费
      shopAvgSpend = '', //人均
    } = data;

    let showShopInfoLine = false; //是否展示信息行，需要根据shopBasicLabelOrder中的字段来判断是否展示
    if (shopBasicLabelOrder) {
      for (let i = 0; i < shopBasicLabelOrder.length; i++) {
        const typeName = shopBasicLabelOrder[i];
        if (typeName && data[typeName]) {
          showShopInfoLine = true;
        }
      }
    }

    if (!showShopInfoLine) {
      return null;
    }

    const isIOS = Mach.env.isIOS;
    const content: any[] = [];
    const fontSize = 12;
    const fontFamily = 'KeeTa-Regular';
    const blackColor = '#222222';
    const baselineOffset = isIOS ? 2.5 : undefined; // 文字使用

    // 分隔符样式
    const placeholder = {
      type: 'placeholder',
      width: 4
    };

    const seperatorTags = [
      placeholder,
      {
        type: 'text',
        fontSize: isIOS ? 16 : fontSize, // ios端小圆点偏小，手动设大一点
        fontFamily,
        text: '·',
        color: '#C2C2C2',
        baselineOffset
      },
      placeholder,
    ];

    for (let i = 0; i < shopBasicLabelOrder.length; i++) {
      if (shopBasicLabelOrder[i] === shopInfoTag.shopScore && shopScoreInfo?.score) {
        if (i > 0 && content.length > 0) {
          content.push(...seperatorTags);
        }
        content.push(this.getRichTextElements(shopScoreInfo?.score, blackColor, 'KeeTa-Bold'));
      } else if (shopBasicLabelOrder[i] === shopInfoTag.shopSale && shopSaleInfo?.amount > 0) {
        if (i > 0 && content.length > 0) {
          content.push(...seperatorTags);
        }
        content.push(this.getRichTextElements(shopSaleInfo?.displayText));
      } else if (shopBasicLabelOrder[i] === shopInfoTag.shopCategory && shopCategoryName) {
        if (i > 0 && content.length > 0) {
          content.push(...seperatorTags);
        }
        content.push(this.getRichTextElements(shopCategoryName));
      } else if (shopBasicLabelOrder[i] === shopInfoTag.shopMinCost && minCostPrice?.amount > 0) {
        if (i > 0 && content.length > 0) {
          content.push(...seperatorTags);
        }
        content.push(this.getRichTextElements(minCostPrice?.displayText));
      } else if (shopBasicLabelOrder[i] === shopInfoTag.shopAvgCost && shopAvgSpend) {
        if (i > 0 && content.length > 0) {
          content.push(...seperatorTags);
        }
        content.push(this.getRichTextElements(shopAvgSpend));
      }
    }

    //没有分隔点的富文本需要删掉baselineOffset
    const hasSeprator = content.some((item) => item.text === '·');
    if (!hasSeprator) {
      content.forEach((item) => {
        delete item.baselineOffset;
        return item;
      });
    }

    const imgClassName = Mach.env.isAndroid ? 'img_icon_time_small shrink-zero' : 'img_icon_time shrink-zero';
    const showScore = shopBasicLabelOrder && shopScoreInfo && shopBasicLabelOrder.includes('shopScoreInfo');
    const hasSeprator1 = content.some((item) => item.text === '·');
    //适配安卓评分星星过高的问题（主要原因是安卓的富文本不能垂直居中导致正常居中的星星反而偏上）
    const marginTop = hasSeprator1 && !isIOS ? 3 : 0;
    return (
      <view style={{
        width: '100%', height: 17, flexDirection: 'row', marginTop: setMarginTop
      }}
      >
        {/* 评分 */}
        {showScore && (
          <view className="rate-container">
            {showScore && <image className={imgClassName} style={{ marginBottom: 1, marginTop }} src={shopScoreInfo?.icon || 'assets://pickup/icon_shop_rate_star_new.png'} />}
          </view>
        )}

        {/* 配送原价和现价的富文本 */}
        {content.length > 0 && <RichText className="shop-info-rich-text-half" content={content} />}
      </view>
    );
  }

  getRichTextElements = (textName: string, textColor: string = '#4D4D4D', fontFamily: string = 'KeeTa-Regular') => {
    const fontSize = 12;
    const baselineOffset = Mach.env.isIOS ? 4 : undefined; // 文字使用

    return {
      type: 'text',
      text: `${textName}`,
      color: textColor,
      fontSize,
      fontFamily,
      baselineOffset
    };
  };
}
